import axiosHandler from '@/utils/axios-handler';
import { AxiosResponse } from 'axios';
import { academyApiUrl } from '@/lib/constants/api';

export interface FeedbackSubmitRequest {
  feedback: string;
  entryUid: string;
  title: string;
  type: 'course' | 'lesson' | 'learning-path';
}

/**
 * Submit feedback for a course, lesson, or learning path
 */
export async function submitFeedback({
  feedback,
  entryUid,
  title,
  type,
}: FeedbackSubmitRequest): Promise<boolean> {
  try {
    let url: string;
    let payload: any;

    switch (type) {
      case 'learning-path':
        url = academyApiUrl(`/v1/learning-path/entry/${entryUid}/feedback`);
        payload = {
          message: feedback,
          learningPath: {
            title,
          },
        };
        break;
      case 'course':
        url = academyApiUrl(`/v1/course/entry/${entryUid}/feedback`);
        payload = {
          message: feedback,
          course: {
            title,
          },
        };
        break;
      case 'lesson':
        url = academyApiUrl(`/v1/lesson/entry/${entryUid}/feedback`);
        payload = {
          message: feedback,
          lesson: {
            title,
          },
        };
        break;
      default:
        throw new Error('Invalid feedback type');
    }

    const response = await axiosHandler({
      method: 'POST',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      data: payload,
      withCredentials: true,
    });

    if ('status' in response && response.status === 200) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
}
